import { useLisReviewSummary } from '@/hooks/useLisReview'
import { formatPendingCount, LIS_PENDING_CLASS, pendingCount, type PendingScope } from '@/lib/lisReview'
import { cn } from '@/lib/utils'

/**
 * Orange count of LIS results waiting for approval in a scope, or nothing when
 * there are none. Reads the shared summary query, so any number of badges on a
 * page cost one request.
 */
export function LisPendingBadge({
  scope,
  className,
}: {
  scope?: PendingScope
  className?: string
}) {
  const { data } = useLisReviewSummary()
  const count = pendingCount(data, scope)
  if (count === 0) return null
  return (
    <span
      title={`${count} LIS result${count === 1 ? '' : 's'} waiting for review`}
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[11px] font-semibold leading-none',
        LIS_PENDING_CLASS,
        className,
      )}
    >
      {formatPendingCount(count)}
    </span>
  )
}
